/**
 * Limited time offer in cart drawer: absolute end time from data-end-iso (no reset on refresh).
 * Add to cart uses Cart AJAX API; refreshes mini cart like the rest of the theme.
 * Multiple offer products use Slick (theme vendor.js) with visible arrows.
 */
(function() {
  'use strict';

  function parseEndMs(root) {
    var iso = root.getAttribute('data-end-iso');
    if (!iso) return NaN;
    var t = Date.parse(iso);
    return isNaN(t) ? NaN : t;
  }

  function hideOfferBlock(root) {
    root.classList.add('cart-limited-offer--gone');
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '0s';
    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var h = Math.floor((totalSec % 86400) / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    if (days > 0) {
      return days + 'd : ' + h + 'h : ' + m + 'm : ' + s + 's';
    }
    if (h > 0) {
      return h + 'h : ' + m + 'm : ' + s + 's';
    }
    if (m > 0) {
      return m + 'm : ' + s + 's';
    }
    return s + 's';
  }

  function initSlick(root) {
    var jq = window.jQuery || window.$;
    if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') return;

    var $slider = jq(root).find('.js-cart-limited-offer-slider');
    if (!$slider.length) return;

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    var slideCount = $slider.children().length;
    if (slideCount === 0) return;

    var rtl = document.documentElement.getAttribute('dir') === 'rtl';

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: slideCount > 1,
      dots: false,
      infinite: slideCount > 1,
      adaptiveHeight: true,
      rtl: rtl,
      prevArrow:
        '<button type="button" class="slick-prev cart-limited-offer__arrow" aria-label="Previous offer"><span aria-hidden="true">&#8249;</span></button>',
      nextArrow:
        '<button type="button" class="slick-next cart-limited-offer__arrow" aria-label="Next offer"><span aria-hidden="true">&#8250;</span></button>'
    });
  }

  function initOffer(root) {
    var timerEl = root.querySelector('.js-cart-limited-offer-timer');
    var endMs = parseEndMs(root);
    var tickTimer;

    if (!timerEl || isNaN(endMs)) {
      if (timerEl) timerEl.textContent = '';
      return;
    }

    if (Date.now() >= endMs) {
      hideOfferBlock(root);
      return;
    }

    function tick() {
      var now = Date.now();
      var left = endMs - now;
      if (left <= 0) {
        hideOfferBlock(root);
        if (tickTimer) clearInterval(tickTimer);
        return;
      }
      timerEl.textContent = formatCountdown(left);
    }

    tick();
    tickTimer = setInterval(tick, 1000);

    initSlick(root);

    root.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('.js-cart-limited-offer-add');
      if (!btn || !root.contains(btn)) return;

      e.preventDefault();
      if (root.classList.contains('cart-limited-offer--gone')) return;

      var slide = btn.closest('.cart-limited-offer__slide');
      if (!slide) return;
      if (slide.getAttribute('data-available') !== 'true') return;

      var variantId = slide.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      var jq = window.jQuery || window.$;
      var done = function() {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      };

      function onSuccess() {
        var styleCart = jq ? jq('.js-mini-cart').attr('data-cartmini') : null;
        if (styleCart !== 'true' && window.theme && theme.alert && theme.alert.new && window.theme.strings) {
          theme.alert.new(theme.strings.addToCartSuccess || '', '', 3000, 'notice');
        }
        if (window.theme && theme.miniCart) {
          theme.miniCart.updateElements();
          theme.miniCart.generateCart();
        }
        done();
      }

      function onError(msg) {
        if (window.theme && theme.alert && theme.alert.new) {
          theme.alert.new('', msg || 'Unable to add to cart', 3000, 'warning');
        }
        done();
      }

      if (jq && jq.post) {
        jq
          .post('/cart/add.js', { id: variantId, quantity: 1 }, null, 'json')
          .done(onSuccess)
          .fail(function(xhr) {
            var data = xhr.responseJSON;
            onError(data && (data.description || data.message));
          });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId, 10), quantity: 1 }] })
        })
          .then(function(res) {
            if (res.ok) return res.json().then(onSuccess);
            return res.json().then(function(err) {
              onError(err.description || err.message);
            });
          })
          .catch(function() {
            onError('');
          });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.js-cart-limited-offer').forEach(initOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
